<template>
  <q-dialog
    :visible="isVisible"
    title="创建方式"
    width="750px"
    :innerScroll="false"
    :offsetHeight="170"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-radio v-model="creationMethod" label="1">创建方式（旧）</el-radio>
    <el-radio v-model="creationMethod" label="2">创建方式（新）</el-radio>
    <div class="temp-style" v-if="creationMethod == 2">
      <el-radio-group v-model="tmpType">
        <div class="item-box">
          <div class="item-style" v-for="item in tempStyleList" :key="item.type">
            <el-image :src="item.img" class="img-1" fit="cover" :preview-src-list="[item.img]"></el-image>
            <el-radio :label="item.type">{{item.name}}</el-radio>
          </div>
        </div>
      </el-radio-group>
    </div>
  </q-dialog>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      creationMethod: '1',
      tmpType: '1',
      tempStyleList: [
        {type: '1',img: 'https://img3.quanyou.com.cn/joyNew/group1/M00/1C/A0/rB8LrWUso5OAdXxUACLQ7T9Z86g275.png',previewImg: '', name: '原始模版'},
        {type: '2',img: 'https://img3.quanyou.com.cn/joyNew/group1/M00/1C/C1/rB8LrWUt-FWAUMm5ABhmAgll5vs225.png',previewImg: '', name: '新店开业模版'},
        {type: '3',img: 'https://img3.quanyou.com.cn/joyNew/group1/M00/22/C7/rB8LrWVleKaAKxJrAB0YDhjjV6s593.png',previewImg: '', name: '周年庆模版'},
        {type: '4',img: 'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/CD/rB8LrmU5vKyAPO7CABOhDm2qUf4518.png',previewImg: '', name: '日常营销模版'},
        {type: '5',img: 'https://img3.quanyou.com.cn/joyNew/group1/M00/1E/56/rB8LrmU_BiaAICGTABTLEbmXd8s171.png',previewImg: '', name: '样板间征集模版'},
        {type: '6',img: 'https://img3.quanyou.com.cn/joyNew/group1/M00/C4/CF/rB8LrWlth4iAM0-EABBGp0S1Drc197.png',previewImg: '', name: '新大转盘模版'},
      ]
    }
  },
  methods: {
    onCancel () {
      this.$emit('update:isVisible',false)
      this.creationMethod = '1'
      this.tmpType = '1'
    },
    onConfirm() {
      this.$emit('update:isVisible',false)
      this.$emit('createMode', {creationMethod: this.creationMethod, tmpType: this.tmpType})
      this.creationMethod = '1' 
      this.tmpType = '1' 
    }
  }
}
</script>

<style lang="stylus" scoped>
  .temp-style {
    margin-top: 20px;
    .item-box {
      display: flex;
      justify-content: space-between;
      margin-right: 100px;
      width: 100%;
      .item-style {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        .img-1 {
          width: 80px;
          height: 100px;
          background: red;
          margin-bottom: 10px;
        }
      }
    }
    
  }
</style>